import { z } from 'zod';

export const placeTypeSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type PlaceTypeEntityApi = z.input<typeof placeTypeSchema>;

export type PlaceTypeEntity = z.infer<typeof placeTypeSchema>;
